import { Link, withPrefix } from 'gatsby';
import { FunctionComponent, default as React, useContext } from 'react';
import Context from '../../context/Context';
import { useEventContext } from '../../context/EventProvider';
import { AuthLink } from '../links';
import PrivacyPolicy from '../privacy';

const Footer: FunctionComponent = (props: any) => {
  const data = useContext(Context);
  const { socialShare } = data;
  const {
    event: { url, email, emailSubject }
  } = useEventContext();

  return (
    <footer>
      <div className="footer-wrapper">
        <div className="footer-container">
          <Link to={withPrefix('/')}>
            <img
              src="https://cdn.ems.prod.upgather.com/uploads/zts_lockup_77c7f1aea8.png"
              alt="Logo"
            />
          </Link>
          <div className="footer-link">
            <a href="https://zerotrustsummit.upgather.com/2024" target="_blank">
              2024
            </a>
            <PrivacyPolicy />
          </div>
        </div>
        <div>
          {socialShare.map((social, index: number) => (
            <a
              key={index}
              className="socialm"
              href={
                social.path
              }
              target="_blank"
            >
              <img
                src={withPrefix(social.img)}
                alt={social.alt}
                width="42px"
                style={{ filter: 'invert(1)' }}
              />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
